module.exports = __webpack_public_path__ + "static/media/pie.00e0d310.png";